module.exports = __webpack_public_path__ + "static/media/changjianxiangqingA@3x.20ee6803.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/changjianxiangqingA@3x.png
// module id = 770
// module chunks = 0